import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getTranslate } from 'react-localize-redux'
import history from '../../history'
import {
  getJobLogs,
  getJobLogDetails
} from '../../redux/actions/dashboardActions'

import JobLogs from '../../components/job-logs'
import Loading from '../../components/loading'

class JobLogsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      pageSize: 20,
      jobTypeFilter: null,
      selectedJobLogId: null
    }
  }

  componentWillMount() {
    this.loadJobLogs()
  }

  loadJobLogs = () => {
    const { page, pageSize, jobTypeFilter } = this.state
    this.props.getJobLogs(page, pageSize, jobTypeFilter)
  }

  handlePageChange = (pageNumber) => {
    this.setState({ page: pageNumber }, () => {
      this.loadJobLogs()
    })
  }

  handleJobTypeFilterChange = (jobType) => {
    this.setState({ page: 1, jobTypeFilter: jobType }, () => {
      this.loadJobLogs()
    })
  }

  handleRowClick = (jobLogId) => {
    this.setState({ selectedJobLogId: jobLogId })
    this.props.getJobLogDetails(jobLogId)
  }

  handleBackToList = () => {
    this.setState({ selectedJobLogId: null })
  }

  handleRefresh = () => {
    if (this.state.selectedJobLogId) {
      this.props.getJobLogDetails(this.state.selectedJobLogId)
    } else {
      this.loadJobLogs()
    }
  }

  handleBackToDashboard = () => {
    history.push('/dashboard')
  }

  render() {
    const { translate, dashboard } = this.props
    const { selectedJobLogId } = this.state

    return (
      <JobLogs
        translate={translate}
        jobLogs={dashboard.jobLogs}
        jobLogDetails={dashboard.jobLogDetails}
        selectedJobLogId={selectedJobLogId}
        onRowClick={this.handleRowClick}
        onBackToList={this.handleBackToList}
        onPageChange={this.handlePageChange}
        onJobTypeFilterChange={this.handleJobTypeFilterChange}
        onRefresh={this.handleRefresh}
        onBackToDashboard={this.handleBackToDashboard}
        currentPage={this.state.page}
        jobTypeFilter={this.state.jobTypeFilter}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  dashboard: state.dashboardReducer,
  translate: getTranslate(state.localeReducer),
  ...state
})

const mapDispatchToProps = {
  getJobLogs,
  getJobLogDetails
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(JobLogsPage)
